import { parseToDateTime } from '@calendly/datetime'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { dateNotationSelector } from 'selectors/current_user'
import { userDateRangeFormat } from 'services/time_format'

export const useDateRangeLabel = ({ startDate, endDate, period }) => {
  const dateNotation = useSelector(dateNotationSelector)

  const buildRangeLabel = () => {
    const from = parseToDateTime(startDate)
    const to = parseToDateTime(endDate)
    if (!from?.isValid || !to?.isValid) return ''
    const [fromStr, toStr] = userDateRangeFormat(
      from, to, dateNotation, 'date_small', 'date_small_with_year',
    )
    return `${fromStr} – ${toStr}`
  }

  switch (period) {
    case 'today':
    case 'this_week':
    case 'this_month':
      return I18n.t(`publisher.scheduled_events.filters.${period}`)
    case 'all_time':
      return I18n.t('publisher.routing.forms.responses.filters.date_range.all_time')
    case 'fixed':
      return buildRangeLabel()
    default:
      return null
  }
}
